module.exports = __webpack_public_path__ + "static/media/after.015655f0.svg";